import type { ReactElement } from 'react';
import { Button } from '@/components/ui/button';
import { cn } from '@/lib/utils';
import type { MCPSourceFilterValue } from './sourceFilter';

const SOURCE_FILTER_OPTIONS: { value: MCPSourceFilterValue; label: string }[] =
  [
    { value: null, label: 'All sources' },
    { value: 'gateway', label: 'MCP Gateway' },
    { value: 'endpoint', label: 'Endpoint Agent' },
  ];

interface MCPSourceFilterButtonsProps {
  source: MCPSourceFilterValue;
  onChange: (source: MCPSourceFilterValue) => void;
}

/** Three source-filter buttons above the MCP Servers table (KIR-3940 AC 2). */
export function MCPSourceFilterButtons({
  source,
  onChange,
}: MCPSourceFilterButtonsProps): ReactElement {
  return (
    <div className="flex items-center gap-2">
      {SOURCE_FILTER_OPTIONS.map(option => {
        const active = option.value === source;
        return (
          <Button
            key={option.label}
            type="button"
            size="sm"
            variant="outline"
            className={cn(
              active &&
                'bg-blue-600 text-white border-blue-600 hover:bg-blue-600/90'
            )}
            onClick={() => onChange(option.value)}
          >
            {option.label}
          </Button>
        );
      })}
    </div>
  );
}
